import { InputText } from "primereact/inputtext";
import { Ripple } from "primereact/ripple";
import React from "react";

interface DataListModalInputProps<T> {
    label: string;
    inputId: string;
    required?: boolean;
    error: string;
    value: T | null;
    displayKey?: keyof T;
    onAdd: () => void;
    placeHolder: string;
    inputClassName?: string;
    formGroupClassName?: string;
    disabled?:boolean;
    hasColorDisplay?: boolean;
    colorDisplayKey?: keyof T;
}

const DataListModalInput = <T extends object>(
    {
        label,
        inputId,
        required,
        error,
        value,
        displayKey,
        onAdd,
        placeHolder,
        inputClassName,
        formGroupClassName,
        disabled,
        hasColorDisplay,
        colorDisplayKey
    }: DataListModalInputProps<T>
) => {
    const displayValue =
        value && displayKey ? String(value[displayKey]) : value ? String(value) : "";

    const colorDisplayValue =
        value && colorDisplayKey ? String(value[colorDisplayKey]) : value ? String(value) : "";

    return (
        <div className={`page_form_group ${formGroupClassName ?? ''}`}>
            <label
                htmlFor={inputId}
                className={`custom_form_label ${required ? 'is_required' : ''}`}
            >
                {label}
            </label>
            <div className="input_with_button_area">
                <InputText
                    id={inputId}
                    value={displayValue}
                    className={`custom_form_input has_add_value ${inputClassName ?? ''}`}
                    placeholder={placeHolder}
                    readOnly={true}
                    autoComplete="off"
                    onClick={onAdd}
                    disabled={disabled}
                />

                {hasColorDisplay && value && (
                    <span className="input_color_display" style={{ backgroundColor: colorDisplayValue }} />
                )}

                <button
                    className="add_value_btn p-ripple"
                    onClick={onAdd}
                    disabled={disabled}
                >
                    {value === null ? (
                        <React.Fragment>
                            <i className="bi bi-plus-lg"></i>
                            <span>Add</span>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <i className="bi bi-pencil-square"></i>
                            <span>Change</span>
                        </React.Fragment>
                    )}
                    <Ripple />
                </button>
            </div>

            {error && (
                <small className="form_error_msg">{error}</small>
            )}
        </div>
    )
}

export default DataListModalInput;